export default __webpack_public_path__ + "static/media/styles_img.24d758c0.png";